import {Component, OnInit} from '@angular/core';
import {LayoutService} from "../../layout.service";

declare var $: any;

@Component({
  selector: 'sa-collapse-menu',
  templateUrl: './collapse-menu.component.html'
})
export class CollapseMenuComponent {

  constructor(
    private layoutService: LayoutService
  ) {

  }

  onToggle() {
    this.layoutService.onCollapseMenu()
  }
}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/layout/header/collapse-menu/collapse-menu.component.ts